module.exports = __webpack_public_path__ + "static/media/Peloton_Logo_White.da186186.svg";